import types from 'redux/types';

const getGuideline = () => {
  return {
    type: types.REQUEST_GET_GUIDE,
  };
};

const getGuidelineByRole = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_GUIDE_BY_ROLE,
  };
};

const saveGuide = (data) => {
  return {
    ...data,
    type: types.REQUEST_SAVE_GUIDE,
  };
};

const reorderGuide = (data) => {
  return {
    ...data,
    type: types.REQUEST_REORDER_GUIDE,
  };
};

const deleteGuide = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_GUIDE,
  };
};

export default {
  deleteGuide,
  reorderGuide,
  getGuideline,
  getGuidelineByRole,
  saveGuide,
};
